import { selectSubscription } from 'logic/member';
import { selectWorkout, workoutPrintUri } from 'logic/workout';

import {
  selectWorkoutIsComplete,
  workoutToggleComplete,
} from 'logic/completions';

export const ProgramWorkout = {
  template: `
    <div class="program-workout">
      <workout>
        <workout-nav-left>
          <button-back>
            Week {{ $ctrl.weekNumber }}
          </button-back>
        </workout-nav-left>
        <workout-header>
          <div class="container mt-4 mb-3">
            <completer
              title="Introduction"
              is-complete="$ctrl.isComplete"
              on-toggle="$ctrl.workoutToggleComplete(
                $ctrl.exercisePlanId,
                $ctrl.id,
                $ctrl.subscription.voomeProductId,
                $ctrl.workout.week,
                'Session ' + $ctrl.workout.week,
                $ctrl.isComplete
              )">
            </completer>
          </div>
        </workout-header>
      </workout>
    </div>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
      },

      $onDestroy() {
        this.disconnect();
      },

      mapState(state) {
        const { exercisePlanId, id, weekNumber } = state.router.currentParams;
        const workout = selectWorkout(state.workout, id);
        const subscription = selectSubscription(state.member);
        const printUri = workoutPrintUri(id, exercisePlanId, subscription.id);

        return {
          exercisePlanId,
          id,
          weekNumber,
          printUri,
          subscription,
          workout,
          isComplete: selectWorkoutIsComplete(state, workout),
        };
      },

      mapDispatch() {
        return {
          workoutToggleComplete,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Program/Workout.js